'use strict';

var RulesReadonlyDirective = function RulesReadonlyDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/rules-readonly.html'),
    controller: 'RulesReadonlyController',
    scope: {
      rule: '=',
      closePanelHandler: '&',
      expandCollapseHandler: '&',
      showHideHandler: '&',
      showDragBar: '=',
      collapsed: '=',
      isHidden: '='
    },
    link: function link($scope) {
      $scope.$on('whatif:showResults', $scope.showWhatIfResultsHandler);
      $scope.$on('readOnly:resetView', $scope.resetReadOnlyView);
      $scope.$watch('rule', $scope.updateWhatIfRequestStatus);
      $scope.toggleWhatIfDropdown = function () {
        $scope.updateWhatIfRequestStatus();
      };
    }
  };
};
RulesReadonlyDirective.$inject = [];
module.exports = RulesReadonlyDirective;